import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delay, finalize, takeUntil, tap } from 'rxjs/operators';

import {
  ComparisonOperator,
  CreateScheduledMessageBulkCommand,
  CustomResultOfGetWhiteMessageCalculationsDto,
  UseTypes,
} from 'src/app/core/api/models';
import {
  Bulk2ServicesService,
  BulkServicesService,
  ScheduledMessagesService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { GetCount2Query } from '../../../core/api/models/get-count-2-query';
import { GetScheduledMessageCalculationsByBulk2Query } from '../../../core/api/models/get-scheduled-message-calculations-by-bulk-2-query';
import { SendTypes } from '../../../core/api/models/send-types';
import { CampaignsFormComponent } from '../campaigns/campaigns-form/campaigns-form.component';
import { SendBalkSmsComponent } from '../send-balk-sms/send-balk-sms.component';
import { AppDomService } from './../../../core/services/dom.service';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';

@Component({
  selector: 'app-send-balk-sms2',
  templateUrl: './send-balk-sms2.component.html',
  styleUrls: [
    '../send-balk-sms/send-balk-sms.component.scss',
    '../base/base-sending-system.component.scss',
  ],
  standalone: false,
})
export class SendBalkSms2Component
  extends SendBalkSmsComponent
  implements OnInit, OnDestroy
{
  tabName: string = 'sendBulkSMS2';

  constructor(
    public dynamicTabService: DynamicTabService,
    protected translate: TranslateService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected currentService: ScheduledMessagesService,
    public CD: ChangeDetectorRef,
    public zoneService: ZonesService,
    public bulkService: BulkServicesService,
    public bulk2Service: Bulk2ServicesService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    protected numberSeparatorPipe: NumberSeparatorPipe
  ) {
    super(
      dynamicTabService,
      translate,
      dialogService,
      utilityService,
      currentService,
      CD,
      zoneService,
      bulkService,
      tabsDynamicComponent,
      numberSeparatorPipe
    );
    this.baseCreateGetApiForSend(
      this.currentService,
      'scheduledMessagesCreateScheduledMessageBulk2Get'
    );
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.pageConfig.title = this.pageVocabs + 'title2';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  calculateStepTotalItemCount(changeInputs: boolean = true) {
    try {
      if (this.calculateCountLoading) return;
      this.calculateCountLoading = true;

      this.totalMobileCount = 0;
      if (changeInputs) {
        this.smsStartFromOnStep = 0;
        this.smsCountToSendOnStep = this.totalMobileCount;
      }
      //TODO: here we most generate the search model and call count function of bulk service to return the number's count
      let model: GetCount2Query = {
        comparisonObjects: [],
        orders: null,
      };
      if (this.stateId && this.stateId != null) {
        model.comparisonObjects.push({
          field: 'StateId',
          operator: ComparisonOperator.EqualTo,
          value: this.stateId.toString(),
        });
      }
      if (this.cityId && this.cityId != null) {
        model.comparisonObjects.push({
          field: 'CityId',
          operator: ComparisonOperator.EqualTo,
          value: this.cityId.toString(),
        });
      }
      if (this.regionId && this.regionId != null) {
        model.comparisonObjects.push({
          field: 'AreaId',
          operator: ComparisonOperator.EqualTo,
          value: this.regionId.toString(),
        });
      }
      if (this.businessGroupId && this.businessGroupId != null) {
        model.comparisonObjects.push({
          field: 'GuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessGroupId.toString(),
        });
      }
      if (this.businessSubGroupId && this.businessSubGroupId != null) {
        model.comparisonObjects.push({
          field: 'SubGuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessSubGroupId.toString(),
        });
      }
      if (this.mobileNumberOperatorIdOnStep != null) {
        model.comparisonObjects.push({
          field: 'MobileOperator',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberOperatorIdOnStep.toString(),
        });
      }
      if (this.mobileNumberStartWith.length > 0) {
        let fldName = 'Mobile';
        model.comparisonObjects.push({
          field: fldName,
          operator: ComparisonOperator.StartsWith,
          value: '98' + this.mobileNumberStartWith,
        });
      }
      if (this.mobileNumberTypeOnStep != null) {
        model.comparisonObjects.push({
          field: 'SimType',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberTypeOnStep.toString(),
        });
      } else {
        //here we return to force the user to select a simtype
        this.dialogService.openDialog({
          message: this.translate.instant(
            this.errorsVocab + 'mostSelectAtLeastSimType'
          ),
          title: this.translate.instant('common.error'),
          status: DialogStatus.error,
        });
        this.calculateCountLoading = false;
        return;
      }
      if (this.gender != null) {
        model.comparisonObjects.push({
          field: 'GenderType',
          operator: ComparisonOperator.EqualTo,
          value: this.gender.toString(),
        });
      }
      if (this.postalCode.length > 0) {
        let fldName = 'ZipCode';
        model.comparisonObjects.push({
          field: fldName,
          operator: ComparisonOperator.StartsWith,
          value: this.postalCode,
        });
      }
      this.bulk2Service
        .bulk2ServicesGetCount({ body: model })
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(
            () => ((this.loading = false), (this.calculateCountLoading = false))
          )
        )
        .subscribe((count) => {
          this.calculateCountLoading = false;
          this.totalMobileCount = count.data;
          if (changeInputs) {
            this.smsStartFromOnStep = 1;
            this.smsCountToSendOnStep = this.totalMobileCount;
            if (this.totalMobileCount == 0) this.smsStartFromOnStep = 0;
          }
        });

      this.isStepTotalItemCountCalculated = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region api
  createScheduledMessageBulkApi(
    requestModel: CreateScheduledMessageBulkCommand
  ) {
    this.unSubs();
    this.loading = true;
    this.sendLoading = true;
    this.currentService
      .scheduledMessagesCreateScheduledMessageBulk2Post({
        body: requestModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result.isSucceed) {
          this.refreshPage();
          this.onSuccess();
        }
      });
  }

  scheduledMessageCalculationsApi(
    model: GetScheduledMessageCalculationsByBulk2Query
  ) {
    this.unSubs();
    this.loading = true;
    this.calcLoading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageCalculationsByBulk2({ body: model })
      .pipe(
        delay(500),
        tap((res: CustomResultOfGetWhiteMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators(),
        finalize(() => (this.calcLoading = false))
      )
      .subscribe();
  }

  //#endregion

  configBaseSendSMS() {
    try {
      this.baseSendSmsConfig = {
        title: this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        msgInfoClassList: 'md:tw-w-1/3 tw-mt-2 offset-md-2',
        sendDateTimeClassList: 'md:tw-w-1/3 tw-mt-2',
        isShowReceivers: false,
        isShowFastSend: false,
        isShowExtraReceivers: true,
        isShowPageHeader: false,
        isShowCampaign: !this.formPageConfig?.isEditMode ? true : false,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: true,
        sendType: SendTypes.Bulk2,
        useType: UseTypes.Normal,
      };
      if (this.formPageConfig.isEditMode) {
        this.baseSendSmsConfig.isEdit = true;
        this.baseSendSmsConfig.isShowExtraReceivers = false;
        //this.baseSendSmsConfig.justShowDirectDateTimeForEdit = true;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onSaveToCampaign(event) {
    try {
      this.model.saveToCampaign = event;
      this.createModel();

      const modalResult = this.dialogService.openModal({
        component: CampaignsFormComponent,
        data: { model: this.model, sendType: SendTypes.Bulk2 },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          this.model.saveToCampaign = res?.isSaveAfterSend;
          if (res?.campaignId) this.model.campaignId = res?.campaignId;
          if (res?.title) this.model.title = res?.title;
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
}
